import { useQuery } from "react-query";
import { useUser } from "@/providers/context";
import { getUserDetails } from "@/api";

export const useUserDetails = () => {
  const { uid } = useUser(); // Details for specific user
  return useQuery(["user_details", uid], () => getUserDetails(), {
    enabled: !!uid,
  });
};
